import {
    AwardsBlock,
    Breadcrumb,
    ContactsBlock,
    CrewMembersBlock,
    DegustationBlock,
    FAQsBlock,
    Footer,
    Header,
    ImagesBlock,
    NavigationBlock,
    PlacesBlock,
    PortfolioBlock,
    Toolbar,
} from 'widgets';
// eslint-disable-next-line no-restricted-imports
import React, { memo, useLayoutEffect } from 'react';
import { Error, PageLayout, useAppDispath } from 'shared';
import { OutdoorBarsPageMain } from './components';
import { OutdoorBarsPageActions, useOutdoorBarsPageState } from '../store';

const MemoBreadcrumb = memo(Breadcrumb);
const MemoFooter = memo(Footer);
const MemoAwardsBlock = memo(AwardsBlock);
const MemoPortfolioBlock = memo(PortfolioBlock);
const MemoPlacesBlock = memo(PlacesBlock);
const MemoFAQsBlock = memo(FAQsBlock);
const MemoDegustationBlock = memo(DegustationBlock);
const MemoImagesBlock = memo(ImagesBlock);
const MemoContactsBlock = memo(ContactsBlock);
const MemoNavigationBlock = memo(NavigationBlock);
const MemoMain = OutdoorBarsPageMain;

export const OutdoorBarsPage = () => {
    const dispatch = useAppDispath();

    const {
        errors,
        title,
        description,
        image,
    } = useOutdoorBarsPageState();

    useLayoutEffect(() => {
        dispatch(OutdoorBarsPageActions.getOutdoorBarsService());
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <PageLayout
            toolbar={<Toolbar />}
        >
            <Header />
            <MemoBreadcrumb />
            {errors.length === 0 ? (
                <MemoMain
                    title={title}
                    description={description}
                    image={image}
                />
            ) : (
                <Error
                    errors={errors}
                    margin="4rem 0"
                />
            )}
            <MemoAwardsBlock />
            <MemoImagesBlock />
            <MemoDegustationBlock />
            <CrewMembersBlock />
            <MemoPortfolioBlock />
            <MemoPlacesBlock />
            <MemoContactsBlock />
            <MemoFAQsBlock />
            <MemoNavigationBlock />
            <MemoFooter />
        </PageLayout>
    );
};
